import React, { forwardRef } from 'react'
import classNames from 'classnames'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	children?: React.ReactNode
	className?: string
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
	const { children, className, id, name, ...rest } = props

	const uniqueId = id || `checkbox-${name}-${Math.random().toString(36).slice(2, 9)}`

	return (
		<div className={classNames('flex space-x-2 items-start', className)}>
			<div className="w-6 h-6 mt-1">
				<input
					ref={ref}
					type="checkbox"
					id={uniqueId}
					name={name}
					className="w-6 h-6 accent-brand-primary-md form-checkbox rounded-md border border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary-md"
					{...rest}
				/>
			</div>
			<label htmlFor={uniqueId} className="flex-1 cursor-pointer">
				{children}
			</label>
		</div>
	)
})

Checkbox.displayName = 'Checkbox'

export default Checkbox
